import { useRfqBuilderView } from '@paradigm/features/src/unified-rfqs/ui';
import CounterpartySelector from '#/components/UnifiedRfqs/components/counterparty-selector/CounterpartySelector';

export default function RfqBuilderCounterpartiesSelector() {
  const { counterpartiesError } = useRfqBuilderView();

  return <CounterpartySelector error={counterpartiesError} />;
}
